// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"36217c7d","355":"e6d28f7c","370":"abd85932","453":"0a47efdf","664":"53da7635","674":"d4a6168a","984":"841d8f82"}[chunkId] + ".chunk.js";
};